import { apiClient } from "../api/ApiClient";
import type { KeyValue } from "../models/KeyValue";
import type { Sale } from "../models/Sale";
import { CreateCrudService } from "./CrudServiceFactory";

export function SaleService(warehouseCode?: string) {
  const crudService = CreateCrudService<Sale, KeyValue>({
    PaginationInPath: true,
    WarehouseCode: warehouseCode,
    SearchReferences: true,
    Route: "sale",
    EntityName: "Sale",
    DeleteAction: "DeleteSale",
    SaveRequest: async (rows) => {
      const normalized = rows.map((row) => {
        const sale = row as Sale;
        return {
          ...sale,
          PaymentDueAt: sale.PaymentDueAt || undefined,
          BalanceDue: Math.max(
            0,
            Number(sale.TotalAmount || 0) - Number(sale.AmountPaid || 0),
          ),
        };
      });
      const response = await apiClient.post<Sale[]>(
        "sale/SaveSale",
        normalized,
      );
      return response.data.map((sale) => ({
        ...sale,
        BalanceDue: Math.max(0, sale.BalanceDue ?? sale.TotalAmount - sale.AmountPaid),
      }));
    },
    PartialFields: ["Code", "CustomerName"],
    LoadingMessage: "Loading sales...",
    SavingMessage: "Saving sale...",
    MapPartial: (value) => ({
      Key: String(value.Code ?? ""),
      Value: String(value.CustomerName ?? value.Code ?? ""),
    }),
  });

  return {
    ...crudService,
  };
}
